<template>
  <modal
    name="review-modal"
    :classes="'customModal'"
    :scrollable="true"
    :reset="true"
    :adaptive="false"
    :width="570"
    height="auto"
    :clickToClose="false"
  >
    <div class="modalWrapper">
      <div class="content__box">
        <div class="content__box__header">
          <div class="top__filter">
            <ul class="top__filter__ul">
              <li class="cursor-default">Reviews</li>
            </ul>
            <ul class="top__filter__ul">
              <li @click="filterreview(1)" :class="{active:reviewFilter===1}">Top Reviews</li>
              <li @click="filterreview(2)" :class="{active:reviewFilter===2}">Most Recent</li>
            </ul>
          </div>
        </div>
        <div class="content__divider"></div>
        <div class="content__box__body review__area" v-if="reviews.length > 0 && !review_loader">
          <div class="review" v-for="(review,index) in reviews" :key="index">
            <div class="d-flex align-items-center flex-wrap cursor-pointer" @click="openSessonModal(review.booking_id,'session-details')">
              <div class="reviewer__image__name">
                <div class="reviewer__image" v-if="review.profile_image">
                  <img :src="review.profile_image" alt="Avatar"/>
                </div>
                <div class="reviewer__image" v-else>
                  {{review.first_name.charAt(0).toUpperCase() + review.last_name.charAt(0).toUpperCase()}}
                </div>
                <div class="reviewer__name">
                  <p class="txt--xs txt-white">{{review.first_name +' ' +review.last_name}}</p>
                </div>
              </div>
              <div class="reviewer__review">
                <div class="review__time">
                  <p class="txt--xs txt--off-white">{{review.created_at | formatDate}}</p>
                </div>
                <div class="review__ratings">
                  <stars-rating :config="modifyUserRating(review.rating)"></stars-rating>
                </div>
              </div>
            </div>
            <div class="review__text" v-if="review.comment">
              <p class="txt--xs txt-white">"{{review.comment}}"</p>
            </div>
          </div>
          <div v-if="load_more" class="d-flex justify-content-center mt-2">
            <button type="button" class="button-load" @click="getReviews()">Load More</button>
          </div>
        </div>
        <div v-else class="content__box__body review__area">
          <div class="d-flex justify-content-center" v-if="review_loader">
            <div class="lds-ring">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
          <p class="d-flex justify-content-center" v-else>No Reviews Found</p>
        </div>
      </div>
      <div class="session__modal__close" @click="closeModal()">
        <i class="fas fa-times"></i>
      </div>
    </div>
  </modal>
</template>

<script>
import starRating from "@/components/StarRating";
//import SessionDetails from "@/components/modals/sessionDetails";
export default {
  name: "Review",

  props: ["space_id"],
  components: {
    "stars-rating": starRating,
    //SessionDetails: SessionDetails
  },
  data() {
    return {
      source_token : null,
      review_loader : false ,
      reviews: [],
      reviewFilter: 2,
      load_more: false,
      page: 1,
      usrconfig: {
        rating: 2.7,
        isIndicatorActive: false,
        style: {
          fullStarColor: "#f5a623",
          emptyStarColor: "#737373",
          starWidth: 12,
          starHeight: 12
        }
      }
    };
  },

  computed: {
    computeModalWidth() {
      if (this.$mq === "lg") return "900px";
      else return "400px";
    }
  },
  created() {
    // window.EventBus.$emit("rating_update", this.usrconfig);
    this.getReviews();
  },
  methods: {
    getReviews() {
      if(this.source_token)
      {
        this.source_token.cancel("Cancel Previous Session");
      }
      const CancelToken = this.axios.CancelToken;
      this.source_token = CancelToken.source();
      this.review_loader = true ;
      this.axios
        .post(window.hostname + "api/auth/all-reviews", {
          device_type: 1,
          // space_id: "5e5968eee4d2303a3b03ef92",
          space_id: this.space_id,
          page: this.page,
          review_filter: this.reviewFilter
        },{
          cancelToken : this.source_token.token
        })
        .then(res => {
          this.review_loader = false ;
          if (res.data.status) {
            if (Object.keys(res.data.data).length !== 0) {
              console.log(res.data.data);
              let data = res.data.data.review_list;
              data.map(val => {
                this.reviews.push(val);
              });
              this.load_more =
                res.data.data.pagination.load_more == 1 ? true : false;
              this.page = res.data.data.pagination.page;
            } else {
              this.reviews = [];
            }
          }
        })
        .catch(err=>{
          if(this.axios.isCancel(err))
          {
            this.review_loader = true ;
            return ;
          }
          else
          {
            this.review_loader = false ;
          }
        });
    },
    filterreview(filter) {
      this.reviewFilter = filter;
      this.page = 1;
      this.load_more = false;
      this.reviews = [];
      this.getReviews();
    },
    modifyUserRating(rating) {
      let usrconfig = {
        rating: parseFloat(rating),
        isIndicatorActive: false,
        style: {
          fullStarColor: "#f5a623",
          emptyStarColor: "#737373",
          starWidth: 12,
          starHeight: 12
        }
      };
      // window.EventBus.$emit("rating_update",usrconfig);
      return usrconfig;
    },
    closeModal() {
      //this.$emit("modal_closed");
      this.$modal.hide("review-modal");
    },
    openSessonModal(session_id,modalName){
    
      if (session_id == "" || session_id == undefined || session_id == null) {
        return;
      }
      var url = window.hostname;
      let formData = {
        booking_id: session_id,
        mode: "show-booking",
        time_zone: this.$moment.tz.guess(new Date()),
        booking_for: "owner",
        list_type: "all",
      };

      url += "/api/auth/booking";
      this.axios
        .post(url, formData)
        .then((res) => {
          if (res.data.status) {
            this.$modal.show("session-details", {
              data: res.data.data.booking_details,
              session_type:
              res.data.data.booking_details.booking_end_date != "" ? 2 : 1,
              triggered_from:'review',
            });
            this.closeModal();
          } else {
            return;
          }
        })
        .catch((err) => {
          return;
        });
    },
   
  }
};
</script>

<style>
.vm--overlay {
  background: rgba(0, 0, 0, 0.9) !important;
}
.star-rating {
  display: flex;
  align-items: center;
}
.star-rating .star-container {
  display: flex;
}
.star-rating .star-container:not(:last-child) {
  margin-right: 5px;
}
</style>
